import React, { useState,useEffect } from "react";
import { CircularProgress, Grid } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import { IoMdPerson } from "react-icons/io";
import ProjectLogo from "../../Assets/Images/Login/PSCAdminPortalLogin.svg";
import CustomInput from "../../Components/CustomInputs/CustomInputs";
import { GreenColorButton, PrimeGrayBorderColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
import { PostMethod } from "../../Helper/api";
import {encryptData } from "../../Helper/Encryptions"

const ForgotPassword = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const [userID, setUserID] = useState("");
  const [loaders, setloaders] = useState(false);
  const [ipaddress, setipaddress] = useState("");

  const RegiterationSubmit = (e) => {
    e.preventDefault();
  };
  useEffect(()=>{
    GetIpaddress()
  },[])
  const GetIpaddress =async()=>{
    try{
      const response =await fetch("https://api.ipify.org/")
      const data =await response.text()
      setipaddress(data)
    }catch(Error){
      console.log("GetIpaddress",Error)
    }
  }
  
  const ValidationEmails = (mail) => {
    /* eslint-disable */
    const regExp =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regExp.test(mail);
    /* eslint-enable */
  };

  const ForgotPasswordValidation = async() => {
    try {
      if (!userID) {
        toast.warn("Enter Valid User ID");
        return;
      }
      if (!ValidationEmails(userID)) {
        toast.warn("Invalid User ID Entered");
        return;
      }
      let url = "candidate/forgotpassword";
      let method = "POST";
      let params = {
        email: encryptData(userID),
        ipaddress:ipaddress
      };
      setloaders(true)
      const response = await PostMethod({ url, method, params });
      if(response.status){
        location?.state ? navigate("/verifyotp", { state: { isForgetPw: true, isApplicants: location.state?.isApplicants,email: userID } }) : navigate("/verifyotp", { state: { isForgetPw: true,email: userID} }) 
        setloaders(false)
      }else{
        setloaders(false)
        if(response.message){
          toast.error(response.message)
        }else{
          toast.error("something went wrong please try again later")
        }
      }
    } catch (err) {
      setloaders(false)
      toast.error("something went wrong please try again later")
      console.log("err in ForgotPasswordValidation", err);
    }
  };

  return (
    <Grid item container className="loginbgbanner" justifyContent={"space-between"} alignItems={"center"} padding={window.innerWidth > 600 ? 6 : 2}>
      <Grid item container lg={5.8} md={5.8} sm={12} xs={12}>
        <h1 className="poppinsBold Text-Prime-Green  text-left">Welcome to <span className="Text-Prime-White">Police Service Commission</span> Recruitment Portal</h1>
      </Grid>
      <Grid item container lg={4} md={4} sm={12} xs={12} marginTop={window.innerWidth > 600 ? 0 : 4} flexDirection={"column"} justifyContent="center" className="bg-white borderRadius12 p-4">
        <img
          src={ProjectLogo}
          alt="Instadoc-Project-Logo"
          className="projectlogo"
        />
        <h4 className="poppinsMedium Text-Prime-Black  text-center pt-3">Forgot Password</h4>
        <Grid item lg={12} md={12} sm={12} xs={12} container flexDirection={"column"}>
          <form
            style={{ width: "100%", display: "contents" }}
            className="loginregister"
            onSubmit={RegiterationSubmit}
          >
            <Grid container>
              <p className=" poppinsMedium Text-Prime-Black pt-3">
                User Id
              </p>
              <CustomInput
                placeholderColor={"#666666"}
                placeholder="Enter your User Id"
                backgroundColor="#FFFFFF"
                width={"100%"}
                maxLength={100}
                marginTop={"1%"}
                InputFrontProps={<IoMdPerson color="#222222" size={22} className="mr-2" />}
                value={userID}
                onChange={(e) => setUserID(e.target.value)}
              />
            </Grid>
            <Grid container justifyContent={"space-between"} sx={{ marginTop: "10%" }}>
              <PrimeGrayBorderColorButton className="px-5 py-2" sx={{ width: "48%" }} onClick={() => { location.state?.isApplicants ? navigate("/candidatelogin") : navigate("/") }}>Back</PrimeGrayBorderColorButton>
              <GreenColorButton
                type="submit"
                className="px-5 py-2"
                sx={{ width: "48%" }}
                disabled={loaders}
                onClick={() => ForgotPasswordValidation()}
              >
                {loaders ?   <CircularProgress size="1rem" style={{ color: "#fff" }} /> :"Send OTP"}
              </GreenColorButton>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
